import {BehaviorSubject, combineLatest} from 'rxjs';
import {wwData$} from './worker-data';
import {filter, map} from 'rxjs/operators';

import TpsltsRecord = ww.TpsltsRecord;
import Msg = ww.Msg;

const tpsltsRecords$ = new BehaviorSubject<Map<string, TpsltsRecord>>(new Map());
const airdropPosTpsltsOrders$ = new BehaviorSubject<Map<string, TpsltsRecord>>(new Map());

wwData$
  .pipe(
    filter((o: Msg<Map<string, TpsltsRecord>>) => o.type === 'tpsltsCache'),
    map((msg) => msg.data)
  )
  .subscribe(tpsltsRecords$);

wwData$
  .pipe(
    filter((o: Msg<Map<string, TpsltsRecord>>) => o.type === 'airdrop-pos-tpslts-cache'),
    map((msg) => msg.data)
  )
  .subscribe(airdropPosTpsltsOrders$);

export const getTpsltsRecords$ = combineLatest([tpsltsRecords$, airdropPosTpsltsOrders$]).pipe(
  map(([tpsltsRecords, airdropPosTpsltsOrders]) => (symbol: string, posSide: PosSide, isAirdrop = false, userID = null, posTerm = '') => {
    if (isAirdrop) {
      return airdropPosTpsltsOrders.get(userID + '_' + posTerm) || createDefaultRecord();
    }
    return tpsltsRecords.get(symbol + (posSide || '')) || createDefaultRecord();
  })
);

export const getTpslType$ = getTpsltsRecords$.pipe(
  map((getTpsltsRecord) => {
    return (symbol: string, posSide: PosSide) => {
      const record = getTpsltsRecord(symbol, posSide);
      const nums = calcRecordNumsByType(record);
      if (nums.entire > 0) {
        return 'Entire';
      }
      if (nums.partial > 0) {
        return 'Partial';
      }
      return 'None';
    };
  })
);

function calcRecordNumsByType(record: TpsltsRecord) {
  return {
    entire: record.tp.Entire.length + record.sl.Entire.length,
    partial: record.tp.Partial.length + record.sl.Partial.length,
  };
}

function createDefaultRecord(): TpsltsRecord {
  return {
    tp: {
      Entire: [],
      Partial: [],
      All: [],
    },
    sl: {
      Entire: [],
      Partial: [],
      All: [],
    },
    ts: {
      All: [],
    },
  };
}
